export { default } from "./src/features-highlight";

export type { UniformFeaturesHighlightProps } from "./src/features-highlight";
